import { BlockedIpTypes } from 'generated/graphql-types';

const blockedIpTypeValues: { [key in BlockedIpTypes]: number } = {
   [BlockedIpTypes.Fail2Ban]: 1,
   [BlockedIpTypes.NDTBlocklist]: 2,
   [BlockedIpTypes.GlobalBlocklist]: 3,
};

/** The allowlist stores the originating firewall as its numeric value, not the graph enum name. */
export function getOriginatingType(type: BlockedIpTypes | null): number | null {
   return type ? blockedIpTypeValues[type] : null;
}

export interface AllowBannedIpDialogData {
   ipAddress: string;
}

export interface AllowBannedIpDialogResult {
   accountId: number;
   ipAddress: string;
   qManageTicketId: string;
}

export interface AllowBannedIpRequest extends AllowBannedIpDialogResult {
   originatingType: number | null;
}
